import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaMapMarkedAlt } from 'react-icons/fa';
import { packagesList, packagesData } from '../../data/packages';
import './PackagesPage.css';

const packageHero = packagesData.alleppey.heroImage;

const PackagesPage = () => {
  return (
    <div className="packages-page">
      <div className="packages-hero" style={{ backgroundImage: `url(${packageHero})` }}>
        <div className="packages-hero-overlay"></div>
        <div className="packages-hero-content">
          <h1>Our Travel Packages</h1>
          <p>Customizable Alleppey experiences with homestay comfort and backwater adventures</p>
        </div>
      </div>

      <section className="packages-intro">
        <div className="container">
          <div className="section-header">
            <h2>Alleppey – Venice of the East</h2>
            <p>Budget-friendly, fully customizable trips with our own homestay and backwater experiences</p>
          </div>
          <div className="intro-content">
            <p>
              Discover Alappuzha (Alleppey), a destination blessed with cultural heritage, religious landmarks,
              serene lakes, and enchanting backwaters. Our homestay offers 3 fully furnished AC rooms with attached
              bathrooms, accommodating up to 15 guests — centrally located just 7–10 km from all major tourist spots.
              Every package can be tailored to your preferences and budget.
            </p>
          </div>
        </div>
      </section>

      <section className="packages-grid-section">
        <div className="container">
          <div className="packages-grid">
            {packagesList.map((pkg) => (
              <div className="package-listing-card" key={pkg.id}>
                <div className="package-listing-image">
                  <img src={pkg.image} alt={pkg.title} />
                  <div className="package-listing-days">
                    <FaCalendarAlt />
                    <span>{pkg.days} Days</span>
                  </div>
                </div>
                <div className="package-listing-info">
                  <h3>{pkg.title}</h3>
                  <p>{pkg.shortDesc}</p>
                  <ul className="package-listing-highlights">
                    {pkg.highlights.map((highlight, index) => (
                      <li key={index}>
                        <FaMapMarkedAlt className="highlight-icon" /> {highlight}
                      </li>
                    ))}
                  </ul>
                  <Link to={`/packages/${pkg.id}`} className="btn btn-outline">
                    View Details
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="packages-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Need a Custom Package?</h2>
            <p>Contact us to plan a personalized Alleppey experience tailored to your dates and budget</p>
            <Link to="/contact" className="btn btn-primary">Custom Package Request</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PackagesPage;
